import { configIP } from '../constants/constants';
const { IP_ENDPOINT, FETCH_TIMEOUT } = configIP

export  const getClientIp = async (): Promise<string | undefined> => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

    try {
      const res = await fetch(IP_ENDPOINT, { signal: controller.signal });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const { ip } = await res.json();
      return typeof ip === 'string' ? ip : undefined;
    } catch (e) {
      console.warn('Не удалось получить IP:', e);
      return undefined; // чёрный ящик должен молчать, а не падать
    } finally {
      clearTimeout(timer);
    }
  };